import React from 'react';
import Lightening from '../../components/lightening/index'

const LighteningPage = () => {

    return (
        <div>

            <Lightening />
        </div>
    )
}

export default LighteningPage;